module.exports = __webpack_public_path__ + "static/media/drone_emergency.c6570f27.svg";